// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"62730494","239":"82f4555c","667":"93e67f94"}[chunkId] + ".chunk.js";
};